<template>
  <div 
    :class="['dots', { 'dots--active': active }]" 
    aria-hidden="true">
    <span 
      :style="{ 'background-color': org.custom_color3 == null ? '': org.custom_color3 }"
      class="dot" />
    <span 
      :style="{ 'background-color': org.custom_color3 == null ? '': org.custom_color3 }"
      class="dot" />
    <span 
      :style="{ 'background-color': org.custom_color3 == null ? '': org.custom_color3 }"
      class="dot" />
  </div>
</template>

<script>

// Vuex
import { mapGetters } from 'vuex';

// Export
export default {
  name: 'module-dots',

  // Props
  props: {
    active: Boolean,
  },

  computed: {
    ...mapGetters('app', ['org']),
  },

};
</script>



// WEBPACK FOOTER //
// Dots.vue?467408a5